import { byPrefixAndName } from '@awesome.me/kit-f16c5d7bca/icons'
import { Box, IconButton, useMediaQuery } from '@chakra-ui/react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'

import ScrollToTop from 'react-scroll-up'

import MFNav from '../../components/MFNav'
import themeConfig from '../../configs/themeConfig'

import { useMFAdminAppInitializer } from '../../contexts/MFAdminAppInitializer'

import '../../@core/scss/base/core/menu/menu-types/vertical-menu.scss'
import '../../@core/scss/base/core/menu/menu-types/vertical-overlay-menu.scss'

/**
 *
 * @param {Object} props
 * @param {import('react').ReactNode} props.children
 * @returns
 */
const VerticalLayout = ({ children }) => {
  const {
    state: {
      layout: {
        footer: { type: footerType }
      }
    }
  } = useMFAdminAppInitializer()

  // ** States
  // const [isMounted, setIsMounted] = useState(false)
  const [menuVisibility, setMenuVisibility] = useState(false)

  const [isDesktop] = useMediaQuery('(min-width: 62em)')

  //** This function will detect the Route Change and will hide the menu on menu item click
  useEffect(() => {
    if (menuVisibility && isDesktop) {
      setMenuVisibility(false)
    }
  }, [isDesktop, menuVisibility])

  return (
    <>
      <MFNav />
      <Box as="main" minH="calc(100vh - 32px)">
        {children}
      </Box>
      {/* <Box as="footer" hidden={footerType === 'hidden'} py={1.5} px={3} position="relative">
        <Text size="sm" color="neutral.800" mb={0} textAlign="center">
          &copy; Marketfuel {new Date().getFullYear()}
        </Text>
      </Box> */}
      {themeConfig.layout.scrollTop === true ? (
        <div className="scroll-to-top">
          <ScrollToTop showUnder={300} style={{ bottom: '5%' }}>
            <IconButton icon={<FontAwesomeIcon icon={byPrefixAndName['fas']['arrow-up']} />} />
          </ScrollToTop>
        </div>
      ) : null}
    </>
  )
}

VerticalLayout.propTypes = { children: PropTypes.node }

export default VerticalLayout
